import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { THEMES } from '../data/theme';
import { Ic, ICONS } from '../data/icons';
import { registerRequest } from '../api/client';

const DEPTS = ['Mühendislik','Pazarlama','Satış','Finans','İK','Tasarım','Hukuk','Operasyon','Genel'];

export default function Register() {
  const C = THEMES['dark'];
  const navigate = useNavigate();
  const [step, setStep]     = useState(1); // 1, 2, 3, 'done'
  const [loading, setLoading] = useState(false);
  const [errors, setErrors]   = useState({});
  const [form, setForm] = useState({ name:'', email:'', password:'', confirmPassword:'', dept:'Genel', phone:'' });

  const set = (key, val) => { setForm(f => ({...f, [key]: val})); setErrors(e => ({...e, [key]: '', general: ''})); };

  const validateStep1 = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Ad Soyad zorunlu';
    else if (form.name.trim().split(' ').length < 2) e.name = 'Lütfen ad ve soyadınızı girin';
    if (!form.email.trim()) e.email = 'E-posta zorunlu';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Geçerli bir e-posta adresi girin';
    setErrors(e);
    return !Object.keys(e).length;
  };

  const validateStep2 = () => {
    const e = {};
    if (!form.password) e.password = 'Şifre zorunlu';
    else if (form.password.length < 8) e.password = 'En az 8 karakter olmalı';
    if (form.password !== form.confirmPassword) e.confirmPassword = 'Şifreler eşleşmiyor';
    setErrors(e);
    return !Object.keys(e).length;
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await registerRequest({ name: form.name, email: form.email, password: form.password, dept: form.dept, phone: form.phone });
      setStep('done');
    } catch (err) {
      setErrors({ general: err.message || 'Kayıt başarısız' });
    } finally {
      setLoading(false);
    }
  };

  const pw = form.password;
  const pwStrength = !pw ? 0 : pw.length >= 12 && /[A-Z]/.test(pw) && /[0-9]/.test(pw) && /[^A-Za-z0-9]/.test(pw) ? 4 : pw.length >= 8 && (/[A-Z]/.test(pw) || /[0-9]/.test(pw)) ? 3 : pw.length >= 8 ? 2 : 1;
  const pwColors  = ['','#ef4444','#f59e0b','#3b82f6','#22c55e'];
  const pwLabels  = ['','Zayıf','Orta','İyi','Güçlü'];

  const inp = (key) => ({
    style: { width:'100%', borderRadius:10, padding:'10px 14px', fontSize:13.5, fontFamily:'inherit', border:`1px solid ${errors[key] ? '#ef4444' : C.border}`, background:C.surface2, color:C.text, outline:'none', boxSizing:'border-box' },
    onFocus: e => e.target.style.borderColor = errors[key] ? '#ef4444' : C.accent,
    onBlur:  e => e.target.style.borderColor = errors[key] ? '#ef4444' : C.border,
  });

  if (step === 'done') return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:C.bg, fontFamily:"'DM Sans','Segoe UI',sans-serif", padding:16 }}>
      <div style={{ width:'100%', maxWidth:420, textAlign:'center' }}>
        <div style={{ width:80, height:80, borderRadius:'50%', background:'rgba(34,197,94,0.15)', border:'2px solid #22c55e44', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 24px' }}>
          <Ic d={ICONS.check} size={36} s='#22c55e' />
        </div>
        <div style={{ fontSize:24, fontWeight:800, color:C.text, marginBottom:10, letterSpacing:'-0.5px' }}>Kayıt Talebiniz Alındı!</div>
        <div style={{ fontSize:14, color:C.textSub, lineHeight:1.7, marginBottom:32 }}>
          Hesabınız oluşturuldu ancak <strong style={{ color:C.text }}>sistem yöneticisi onayı</strong> bekleniyor.<br />
          Onaylandıktan sonra e-posta adresiniz ve şifreniz ile giriş yapabilirsiniz.
        </div>
        <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, padding:'16px 20px', marginBottom:28, textAlign:'left' }}>
          <div style={{ fontSize:11.5, fontWeight:700, color:C.textFaint, letterSpacing:'0.5px', marginBottom:10 }}>KAYIT BİLGİLERİ</div>
          {[['Ad Soyad',form.name],['E-posta',form.email],['Departman',form.dept],['Rol','Okuyucu (varsayılan)']].map(([l,v]) => (
            <div key={l} style={{ display:'flex', justifyContent:'space-between', marginBottom:6, fontSize:13 }}>
              <span style={{ color:C.textFaint }}>{l}</span>
              <span style={{ color:C.text, fontWeight:600 }}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{ background:'rgba(59,130,246,0.08)', border:'1px solid rgba(59,130,246,0.2)', borderRadius:12, padding:'12px 16px', fontSize:12.5, color:'#93c5fd', marginBottom:24, lineHeight:1.6 }}>
          💡 Onay durumunuz değiştiğinde sistem yöneticinizle iletişime geçebilirsiniz.
        </div>
        <button onClick={() => navigate('/login')} style={{ width:'100%', height:46, borderRadius:12, border:'none', background:'linear-gradient(135deg,#3b82f6,#6366f1)', color:'#fff', fontSize:14, fontWeight:700, cursor:'pointer' }}>
          Giriş Sayfasına Dön
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:C.bg, fontFamily:"'DM Sans','Segoe UI',sans-serif", padding:16 }}>
      <div style={{ position:'fixed', top:'-10%', right:'-5%', width:500, height:500, borderRadius:'50%', background:'radial-gradient(circle,rgba(139,92,246,0.07) 0%,transparent 70%)', pointerEvents:'none' }} />

      <div style={{ width:'100%', maxWidth:440 }}>
        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ width:52, height:52, background:'linear-gradient(135deg,#3b82f6,#8b5cf6)', borderRadius:14, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px', boxShadow:'0 8px 24px rgba(59,130,246,0.3)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
          </div>
          <div style={{ fontSize:24, fontWeight:900, color:C.text, letterSpacing:'-0.5px' }}>CorpMDM</div>
          <div style={{ fontSize:12, color:C.textFaint, marginTop:3 }}>Hesap Oluştur</div>
        </div>

        {/* Adım göstergesi */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', marginBottom:24 }}>
          {[1,2,3].map((s,i) => (
            <React.Fragment key={s}>
              <div style={{ width:28, height:28, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11.5, fontWeight:700,
                background: step > s ? '#22c55e' : step === s ? C.accent : C.surface2,
                color: step >= s ? '#fff' : C.textFaint,
                border: `2px solid ${step > s ? '#22c55e' : step === s ? C.accent : C.border}`,
                transition:'all 0.2s' }}>
                {step > s ? <Ic d={ICONS.check} size={12} s='#fff' /> : s}
              </div>
              {i < 2 && <div style={{ width:52, height:2, background: step > s ? '#22c55e' : C.border, transition:'background 0.3s' }} />}
            </React.Fragment>
          ))}
        </div>

        <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:20, padding:'26px 26px 22px', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>

          {errors.general && (
            <div style={{ background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#f87171', marginBottom:18, display:'flex', gap:8, alignItems:'center' }}>
              <Ic d={ICONS.alert} size={14} s='#f87171' /> {errors.general}
            </div>
          )}

          {/* Step 1 — Kişisel bilgiler */}
          {step === 1 && (
            <>
              <div style={{ fontSize:16, fontWeight:800, color:C.text, marginBottom:3 }}>Kişisel Bilgiler</div>
              <div style={{ fontSize:12.5, color:C.textFaint, marginBottom:22 }}>Adınız ve iletişim bilgilerinizi girin</div>
              <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
                <div>
                  <label style={{ fontSize:11.5, fontWeight:600, color:C.textSub, display:'block', marginBottom:6 }}>Ad Soyad *</label>
                  <input value={form.name} onChange={e=>set('name',e.target.value)} placeholder='Ahmet Yılmaz' {...inp('name')} />
                  {errors.name && <div style={{ fontSize:11, color:'#f87171', marginTop:4 }}>{errors.name}</div>}
                </div>
                <div>
                  <label style={{ fontSize:11.5, fontWeight:600, color:C.textSub, display:'block', marginBottom:6 }}>E-posta *</label>
                  <input type='email' value={form.email} onChange={e=>set('email',e.target.value)} placeholder='ahmet@sirket.com' {...inp('email')} />
                  {errors.email && <div style={{ fontSize:11, color:'#f87171', marginTop:4 }}>{errors.email}</div>}
                </div>
                <div>
                  <label style={{ fontSize:11.5, fontWeight:600, color:C.textSub, display:'block', marginBottom:6 }}>Telefon <span style={{ color:C.textFaint, fontWeight:400 }}>(isteğe bağlı)</span></label>
                  <input type='tel' value={form.phone} onChange={e=>set('phone',e.target.value)} placeholder='+90 555 000 0000' {...inp('phone')} />
                </div>
              </div>
              <button onClick={() => validateStep1() && setStep(2)} style={{ width:'100%', height:44, marginTop:22, borderRadius:11, border:'none', background:`linear-gradient(135deg,${C.accent},#6366f1)`, color:'#fff', fontSize:13.5, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
                Devam Et <Ic d={ICONS.arrowR} size={14} s='#fff' />
              </button>
            </>
          )}

          {/* Step 2 — Şifre */}
          {step === 2 && (
            <>
              <div style={{ fontSize:16, fontWeight:800, color:C.text, marginBottom:3 }}>Şifre Oluştur</div>
              <div style={{ fontSize:12.5, color:C.textFaint, marginBottom:22 }}>Güçlü bir şifre belirleyin</div>
              <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
                <div>
                  <label style={{ fontSize:11.5, fontWeight:600, color:C.textSub, display:'block', marginBottom:6 }}>Şifre *</label>
                  <input type='password' value={form.password} onChange={e=>set('password',e.target.value)} placeholder='En az 8 karakter' {...inp('password')} />
                  {errors.password && <div style={{ fontSize:11, color:'#f87171', marginTop:4 }}>{errors.password}</div>}
                  {pw && (
                    <div style={{ marginTop:8 }}>
                      <div style={{ display:'flex', gap:4, marginBottom:4 }}>
                        {[1,2,3,4].map(i => <div key={i} style={{ flex:1, height:3, borderRadius:2, background:pwStrength>=i?pwColors[pwStrength]:C.border2, transition:'background 0.2s' }} />)}
                      </div>
                      <div style={{ fontSize:11, color:pwColors[pwStrength] }}>{pwLabels[pwStrength]}</div>
                    </div>
                  )}
                </div>
                <div>
                  <label style={{ fontSize:11.5, fontWeight:600, color:C.textSub, display:'block', marginBottom:6 }}>Şifre Tekrar *</label>
                  <input type='password' value={form.confirmPassword} onChange={e=>set('confirmPassword',e.target.value)} placeholder='Şifrenizi tekrarlayın' {...inp('confirmPassword')} />
                  {errors.confirmPassword && <div style={{ fontSize:11, color:'#f87171', marginTop:4 }}>{errors.confirmPassword}</div>}
                  {form.confirmPassword && form.password === form.confirmPassword && (
                    <div style={{ fontSize:11, color:'#22c55e', marginTop:4, display:'flex', alignItems:'center', gap:4 }}><Ic d={ICONS.check} size={11} s='#22c55e' /> Şifreler eşleşiyor</div>
                  )}
                </div>
              </div>
              <div style={{ display:'flex', gap:10, marginTop:22 }}>
                <button onClick={() => setStep(1)} style={{ flex:1, height:44, borderRadius:11, border:`1px solid ${C.border}`, background:'transparent', color:C.textSub, fontSize:13, fontWeight:600, cursor:'pointer' }}>← Geri</button>
                <button onClick={() => validateStep2() && setStep(3)} style={{ flex:2, height:44, borderRadius:11, border:'none', background:`linear-gradient(135deg,${C.accent},#6366f1)`, color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
                  Devam Et <Ic d={ICONS.arrowR} size={14} s='#fff' />
                </button>
              </div>
            </>
          )}

          {/* Step 3 — Departman + özet */}
          {step === 3 && (
            <>
              <div style={{ fontSize:16, fontWeight:800, color:C.text, marginBottom:3 }}>Departman Seçimi</div>
              <div style={{ fontSize:12.5, color:C.textFaint, marginBottom:22 }}>Çalıştığınız departmanı seçin</div>

              {/* Rol bilgisi notu */}
              <div style={{ background:'rgba(59,130,246,0.08)', border:'1px solid rgba(59,130,246,0.2)', borderRadius:10, padding:'11px 14px', marginBottom:18, fontSize:12.5, color:'#93c5fd', display:'flex', gap:8, alignItems:'flex-start' }}>
                <Ic d={ICONS.info} size={15} s='#93c5fd' style={{ marginTop:1 }} />
                <div>Yeni hesaplar <strong>Okuyucu</strong> rolüyle açılır. Sistem yöneticisi onayladıktan sonra rolünüz değiştirilebilir.</div>
              </div>

              <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
                <div>
                  <label style={{ fontSize:11.5, fontWeight:600, color:C.textSub, display:'block', marginBottom:8 }}>Departman</label>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:7 }}>
                    {DEPTS.map(d => (
                      <button key={d} onClick={() => set('dept', d)} style={{ padding:'9px 10px', borderRadius:9, border:`1px solid ${form.dept===d ? C.accentBorder : C.border}`, background:form.dept===d ? C.accentBg : 'transparent', color:form.dept===d ? C.accent : C.textSub, fontSize:12.5, fontWeight:form.dept===d?700:400, cursor:'pointer', transition:'all 0.15s', textAlign:'center' }}>
                        {d}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Özet */}
                <div style={{ background:C.surface2, borderRadius:12, padding:'14px 16px', border:`1px solid ${C.border}` }}>
                  <div style={{ fontSize:11, fontWeight:700, color:C.textFaint, letterSpacing:'0.5px', marginBottom:10 }}>ÖZET</div>
                  {[['Ad Soyad',form.name],['E-posta',form.email],['Departman',form.dept],['Rol','Okuyucu (onay sonrası değiştirilebilir)']].map(([l,v]) => (
                    <div key={l} style={{ display:'flex', justifyContent:'space-between', marginBottom:6, fontSize:12.5 }}>
                      <span style={{ color:C.textFaint }}>{l}</span>
                      <span style={{ color:C.text, fontWeight:600 }}>{v}</span>
                    </div>
                  ))}
                  <div style={{ display:'flex', justifyContent:'space-between', marginTop:6, fontSize:12.5 }}>
                    <span style={{ color:C.textFaint }}>Durum</span>
                    <span style={{ color:'#f59e0b', fontWeight:700 }}>⏳ Onay Bekliyor</span>
                  </div>
                </div>
              </div>

              <div style={{ display:'flex', gap:10, marginTop:22 }}>
                <button onClick={() => setStep(2)} style={{ flex:1, height:44, borderRadius:11, border:`1px solid ${C.border}`, background:'transparent', color:C.textSub, fontSize:13, fontWeight:600, cursor:'pointer' }}>← Geri</button>
                <button onClick={handleSubmit} disabled={loading} style={{ flex:2, height:44, borderRadius:11, border:'none', background:'linear-gradient(135deg,#22c55e,#16a34a)', color:'#fff', fontSize:13, fontWeight:700, cursor:loading?'wait':'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8, opacity:loading?0.8:1 }}>
                  {loading ? 'Kaydediliyor...' : <><Ic d={ICONS.check} size={14} s='#fff' /> Kayıt Talebi Gönder</>}
                </button>
              </div>
            </>
          )}
        </div>

        <div style={{ textAlign:'center', marginTop:18, fontSize:12.5, color:C.textFaint }}>
          Zaten hesabınız var mı?{' '}
          <button onClick={() => navigate('/login')} style={{ background:'none', border:'none', cursor:'pointer', color:C.accent, fontWeight:600, fontSize:12.5 }}>Giriş Yap</button>
        </div>
      </div>
    </div>
  );
}
